import { render, staticRenderFns } from "./chooseCompanyType.vue?vue&type=template&id=13b46ab8&scoped=true&"
import script from "./chooseCompanyType.vue?vue&type=script&lang=js&"
export * from "./chooseCompanyType.vue?vue&type=script&lang=js&"
import style0 from "./chooseCompanyType.vue?vue&type=style&index=0&id=13b46ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b46ab8",
  null
  
)

export default component.exports